<template>
   <div>
      <v-card flat>
         <v-card-title>Applicant Statement</v-card-title>
         <v-card-text>
            <p>I, <i>{{ membership ? membership.fullname : "" }}</i>, desire to be admitted as <span v-html="membership ? formatCategory(membership.membertype) : ''"></span> of the Malaysian Institute of Planners
               and declare that the information supplied herewith is true in every respect. I undertake to adhere to the Malaysian Institute
               of Planners Code of Professional Conduct, Regulations, and Charter &amp; Bylaws throughout my membership of the Malaysian Institute
               of Planners.</p>
            <p>The Malaysian Institute of Planners Code of Professional Conduct, Regulations and Charter &amp; Bylaws are subject to change and are
               available for members to view online or a hard copy is available on request.</p>
         </v-card-text>
      </v-card>

      <v-divider inset></v-divider>

      <v-card flat>
         <v-card-title>Nomination</v-card-title>
            <v-card-text>
            <v-alert v-if="message" :type="messageType" dense text class="mb-4">
               {{ message }}
            </v-alert>

            <v-row>
               <v-col cols="12" md="6">
                  <v-card outlined>
                     <v-card-text>
                        <v-list-item-subtitle class="text-wrap mb-4">Proposer</v-list-item-subtitle>

                        <v-autocomplete
                           v-model="selectedProposer"
                           :items="proposerItems"
                           :search-input.sync="proposerSearch"
                           :loading="loadingProposer"
                           item-text="fullname"
                           item-value="userid"
                           return-object
                           clearable
                           chips
                           deletable-chips
                           hide-no-data
                           label="Proposer"
                           @change="onProposerChanged"
                        >
                           <template v-slot:selection="{ item }">
                              <v-chip color="blue-grey" text-color="white" small>
                                 <v-avatar left v-if="item.photolink">
                                    <v-img :src="'/' + item.photolink"></v-img>
                                 </v-avatar>
                                 {{ item.fullname }}
                              </v-chip>
                           </template>
                           <template v-slot:item="{ item }">
                              <v-list-item-avatar v-if="item.photolink">
                                 <v-img :src="'/' + item.photolink"></v-img>
                              </v-list-item-avatar>
                              <v-list-item-content>
                                 <v-list-item-title>{{ item.fullname }}</v-list-item-title>
                                 <v-list-item-subtitle>{{ item.memberid || item.lpbmno || item.contactemail }}</v-list-item-subtitle>
                              </v-list-item-content>
                           </template>
                        </v-autocomplete>

                        <v-btn
                           color="primary"
                           class="mt-4"
                           :disabled="!selectedProposer || submittingProposer || proposerSent"
                           :loading="submittingProposer"
                           @click="submitProposer"
                        >
                           {{ proposerSent ? 'PROPOSER NOMINATION SENT' : 'SUBMIT PROPOSER NOMINATION' }}
                        </v-btn>

                        <div v-if="latestProposer" class="mt-4 caption">
                           Status: <b>{{ responseText(latestProposer.responsetype) }}</b>
                           <span v-if="latestProposer.datesent"> | Sent: {{ formatDate(latestProposer.datesent) }}</span>
                        </div>
                     </v-card-text>
                  </v-card>
               </v-col>

               <v-col cols="12" md="6" v-if="membership && membership.membertype !== 'STU'">
                  <v-card outlined>
                     <v-card-text>
                        <v-list-item-subtitle class="text-wrap mb-4">Seconder</v-list-item-subtitle>

                        <v-autocomplete
                           v-model="selectedSeconder"
                           :items="seconderItems"
                           :search-input.sync="seconderSearch"
                           :loading="loadingSeconder"
                           item-text="fullname"
                           item-value="userid"
                           return-object
                           clearable
                           chips
                           deletable-chips
                           hide-no-data
                           label="Seconder"
                           @change="onSeconderChanged"
                        >
                           <template v-slot:selection="{ item }">
                              <v-chip color="blue-grey" text-color="white" small>
                                 <v-avatar left v-if="item.photolink">
                                    <v-img :src="'/' + item.photolink"></v-img>
                                 </v-avatar>
                                 {{ item.fullname }}
                              </v-chip>
                           </template>
                           <template v-slot:item="{ item }">
                              <v-list-item-avatar v-if="item.photolink">
                                 <v-img :src="'/' + item.photolink"></v-img>
                              </v-list-item-avatar>
                              <v-list-item-content>
                                 <v-list-item-title>{{ item.fullname }}</v-list-item-title>
                                 <v-list-item-subtitle>{{ item.memberid || item.lpbmno || item.contactemail }}</v-list-item-subtitle>
                              </v-list-item-content>
                           </template>
                        </v-autocomplete>

                        <v-btn
                           color="primary"
                           class="mt-4"
                           :disabled="!selectedSeconder || submittingSeconder || seconderSent"
                           :loading="submittingSeconder"
                           @click="submitSeconder"
                        >
                           {{ seconderSent ? 'SECONDER NOMINATION SENT' : 'SUBMIT SECONDER NOMINATION' }}
                        </v-btn>

                        <div v-if="latestSeconder" class="mt-4 caption">
                           Status: <b>{{ responseText(latestSeconder.responsetype) }}</b>
                           <span v-if="latestSeconder.datesent"> | Sent: {{ formatDate(latestSeconder.datesent) }}</span>
                        </div>
                     </v-card-text>
                  </v-card>
               </v-col>
            </v-row>
         </v-card-text>
      </v-card>

      <v-divider inset></v-divider>

      <v-checkbox
         v-model="form.isagreed"
         class="center"
         label="Applicant Statement Completed"
         @change="accepted"
         dense
      />
   </div>
</template>

<script>
const axios = require('axios')

export default {
   name: "TableDecl",

   data() { return {
      userid: 0,
      membership: null,
      form: {
         isagreed: false
      },
      message: "",
      messageType: "info",
      proposerItems: [],
      seconderItems: [],
      proposerSearch: "",
      seconderSearch: "",
      proposerTimer: null,
      seconderTimer: null,
      selectedProposer: null,
      selectedSeconder: null,
      latestProposer: null,
      latestSeconder: null,
      loadingProposer: false,
      loadingSeconder: false,
      submittingProposer: false,
      submittingSeconder: false,
      membertypes: [
         { const: "ASC", title: "an <b>Associate Member</b>" },
         { const: "STU", title: "a <b>Student Member</b>" },
         { const: "GRA", title: "a <b>Graduate Member</b>" },
         { const: "COR", title: "a <b>Corporate Member</b>" },
         { const: "FEL", title: "a <b>Fellow Member</b>" },
         { const: "HON", title: "a <b>Honorary Member</b>" },
         { const: "PAT", title: "a <b>Patron</b>" }
      ],
   }},

   computed: {
      proposerSent() {
         return !!this.latestProposer
      },

      seconderSent() {
         return !!this.latestSeconder
      },

      requiresSeconder() {
         return this.membership && this.membership.membertype !== 'STU'
      }
   },

   watch: {
      proposerSearch(value) {
         clearTimeout(this.proposerTimer)
         this.proposerTimer = setTimeout(() => this.searchProposer(value || ""), 300)
      },

      seconderSearch(value) {
         clearTimeout(this.seconderTimer)
         this.seconderTimer = setTimeout(() => this.searchSeconder(value || ""), 300)
      }
   },

   methods: {
      accepted() {
         this.$emit('accepted', this.isvalid() ? 'OK' : 'INVALID')
      },

      update() {
         if (this.isvalid()) {
            this.$emit('declupdated')
            return
         }

         this.messageType = "error"
         this.message = "Please submit proposer nomination" + (this.requiresSeconder ? " and seconder nomination" : "") + ", then complete the applicant statement."
         this.$emit('accepted', 'INVALID')
      },

      setuserid(pUserID) {
         this.userid = pUserID
         this.initialize()
      },

      initialize() {
         this.$nextTick(() => {
            this.loadmembership()
            this.loadExistingAcknowledgements()
            this.searchProposer("")
            this.searchSeconder("")
         })
      },

      loadmembership() {
         var targetPath = '/member/info/' + this.userid
         axios.get(targetPath)
         .then((resp) => {
            if (resp.data && resp.data.status === 'OK') {
               this.membership = resp.data.data
               this.accepted()
            }
         })
      },

      loadExistingAcknowledgements() {
         this.loadProposerAck()
         this.loadSeconderAck()
      },

      loadProposerAck() {
         axios.get('/member/decl/getackproposer/' + this.userid)
         .then((resp) => {
            if (resp.data && resp.data.status === 'OK' && resp.data.data.length > 0) {
               this.latestProposer = resp.data.data[0]
               this.selectedProposer = this.normalizeMember(this.latestProposer, 'proposerid')
               this.proposerItems = this.mergeMember(this.proposerItems, this.selectedProposer)
            }
            this.accepted()
         })
      },

      loadSeconderAck() {
         axios.get('/member/decl/getackseconder/' + this.userid)
         .then((resp) => {
            if (resp.data && resp.data.status === 'OK' && resp.data.data.length > 0) {
               this.latestSeconder = resp.data.data[0]
               this.selectedSeconder = this.normalizeMember(this.latestSeconder, 'seconderid')
               this.seconderItems = this.mergeMember(this.seconderItems, this.selectedSeconder)
            }
            this.accepted()
         })
      },

      searchProposer(thename) {
         this.loadingProposer = true
         axios.post('/member/decl/listproposer', { thename })
         .then((resp) => {
            if (resp.data && resp.data.status === 'OK') {
               this.proposerItems = resp.data.data
            }
            if (this.selectedProposer) {
               this.proposerItems = this.mergeMember(this.proposerItems, this.selectedProposer)
            }
         })
         .finally(() => {
            this.loadingProposer = false
         })
      },

      searchSeconder(thename) {
         this.loadingSeconder = true
         axios.post('/member/decl/listseconder', { thename })
         .then((resp) => {
            if (resp.data && resp.data.status === 'OK') {
               this.seconderItems = resp.data.data
            }
            if (this.selectedSeconder) {
               this.seconderItems = this.mergeMember(this.seconderItems, this.selectedSeconder)
            }
         })
         .finally(() => {
            this.loadingSeconder = false
         })
      },

      submitProposer() {
         if (!this.selectedProposer) {
            return
         }

         this.submittingProposer = true
         axios.post('/member/decl/sendackproposer', { proposerid: this.selectedProposer.userid })
         .then((resp) => {
            if (resp.data && resp.data.status === 'OK') {
               this.messageType = "success"
               this.message = "Proposer nomination has been sent."
               this.loadProposerAck()
            } else if (resp.data) {
               this.messageType = "error"
               this.message = resp.data.error
            }
         })
         .finally(() => {
            this.submittingProposer = false
         })
      },

      submitSeconder() {
         if (!this.selectedSeconder) {
            return
         }

         this.submittingSeconder = true
         axios.post('/member/decl/sendackseconder', { seconderid: this.selectedSeconder.userid })
         .then((resp) => {
            if (resp.data && resp.data.status === 'OK') {
               this.messageType = "success"
               this.message = "Seconder nomination has been sent."
               this.loadSeconderAck()
            } else if (resp.data) {
               this.messageType = "error"
               this.message = resp.data.error
            }
         })
         .finally(() => {
            this.submittingSeconder = false
         })
      },

      onProposerChanged() {
         this.latestProposer = null
         this.form.isagreed = false
         this.accepted()
      },

      onSeconderChanged() {
         this.latestSeconder = null
         this.form.isagreed = false
         this.accepted()
      },

      normalizeMember(item, idKey) {
         return {
            userid: item.userid || item[idKey],
            fullname: item.fullname,
            memberid: item.memberid,
            membertype: item.membertype,
            lpbmno: item.lpbmno,
            contactmobile: item.contactmobile,
            contactemail: item.contactemail,
            photolink: item.photolink
         }
      },

      mergeMember(items, member) {
         if (!member) {
            return items
         }
         return [member].concat(items.filter(item => item.userid !== member.userid))
      },

      responseText(value) {
         if (parseInt(value) === 1) return "Accepted"
         if (parseInt(value) === 2) return "Rejected"
         return "Pending"
      },

      formatDate(value) {
         return value ? this.$moment(value).format('DD/MM/YYYY') : ''
      },

      formatCategory(e) {
         var membercategory = this.membertypes.find(obj => {
            return obj.const === e
         })
         return membercategory ? membercategory.title : ''
      },

      isvalid() {
         if (!this.form.isagreed || !this.proposerSent) {
            return false
         }

         if (this.requiresSeconder && !this.seconderSent) {
            return false
         }

         return true
      },
   },

   mounted() {
      this.initialize()
   }
}
</script>
